<template>
  <div class="loading-screen">
    <div class="spinner"></div>
    <div class="loading-message">{{ messages[currentMessage] }}</div>
  </div>
</template>

<script>
export default {
  name: 'LoadingScreen',
  props: {
    loading: Boolean,
    messages: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      currentMessage: 0,
      interval: null,
    };
  },
  mounted() {
    let index = 0;
    this.currentMessage = index;
    this.interval = setInterval(() => {
      if (this.messages.length > 0) {
        this.currentMessage = index;
        index = (index + 1) % this.messages.length;
      }
    }, 2000);
  },
  beforeUnmount() {
    clearInterval(this.interval);
  }
};
</script>


<style>
.loading-screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #001F5A;
  z-index: 9999;
  text-align: center;
  color: white;
  font-size: 24px;
  padding-top: 200px;
}

.loading-message {
  font-size: 20px;
  animation: loadingAnimation 2s infinite;
}

@keyframes loadingAnimation {
  0% { opacity: 0.5; }
  50% { opacity: 1; }
  100% { opacity: 0.5; }
}

.spinner {
  width: 50px;
  height: 50px;
  border: 5px solid rgba(255, 255, 255, 0.3);
  border-top: 5px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 20px auto;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
